import { Injectable } from '@angular/core';

interface PromiseQueueItem {
    function: any;
    arguments: any;
}

@Injectable({
    providedIn: 'root'
})
export class BlockerChainService {
    private promiseQueue: PromiseQueueItem[] = [];

    addPromiseReturningFunction(promiseReturningFunction: (...args: any[]) => Promise<any>, promiseFunctionArguments: any = []) {
        if (promiseReturningFunction) {
            this.promiseQueue.push({
                function: promiseReturningFunction,
                arguments: promiseFunctionArguments
            });
        }
    }

    async executeChain(): Promise<boolean> {
        for (const { function: fn, arguments: args } of this.promiseQueue) {
            try {
                await fn(...args);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error executing function in chain:', error);
            }
        }
        return true;
    }

    clearState() {
        this.promiseQueue = [];
    }
}
